import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { AnnouncementDataRequestModel, AnnouncementModel } from 'src/app/models/orphan/announcement';
import { TaskDataRequestModel } from 'src/app/models/orphan/task-info';
import { AnnouncementService } from 'src/app/services/orphan/announcement.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html'
})
export class AnnouncementComponent implements OnInit {

  isPageDone = false;
  model: AnnouncementModel[];
  dataCount: number;
  requestModel = new AnnouncementDataRequestModel();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    public service: AnnouncementService,
    public formBuilder: FormBuilder,
    private utilsService: UtilsService
  ) {
    this.utilsService.setTitle("Duyurular");
  }

  ngOnInit(): void {
    this.reloadList();
  }

  reloadList(): void {
    this.requestModel.maxResultCount = this.paginator?.pageSize ?? 5;
    this.requestModel.skipCount = this.requestModel.maxResultCount * (this.paginator?.pageIndex ?? 0);

    let paramsString = this.utilsService.urlSearchParamConvertToString(this.requestModel);
    this.service.getActiveAll(paramsString).subscribe(result => {
      this.model = result.items;
      this.dataCount = result.totalCount;
      this.isPageDone = true;
    });
  }

  getServerData() {
    this.requestModel.maxResultCount = this.paginator.pageSize;
    this.requestModel.skipCount = this.paginator.pageSize * this.paginator.pageIndex;
    this.reloadList();
  }

}
